export default __webpack_public_path__ + "static/sparkle-payment-page-e46c32b2432fcdcb565d1769f43db65f.png";